export const ROUTES = {
  INDEX: '/admin.html',
  LOGIN: '/admin-login.html',
  INVITE: '/admin-invite.html',
  VERIFICATION: '/admin-verification.html',
  BALANCE: '/admin-balance.html',
  CUSTOMIZE: '/customize-panel.html',
};
